// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"CustomCalendarNavNext_loadMore__PdTWw","arrow":"CustomCalendarNavNext_arrow__wmks8"};